export default {
  ok: {
    en: 'OK',
    ko: '확인',
  },
  gnb: {
    ceo: {
      kim: {
        pos: {
          en: 'CEO &nbsp;&middot;&nbsp; Chairman',
          ko: '대표이사 &nbsp;&middot;&nbsp; 이사회의장',
        },
        nm: {
          en: 'Jay Kim',
          ko: '김정균',
        }
      },
      chang: {
        pos: {
          en: 'CEO(Pharma Biz)',
          ko: '대표이사(제약사업부문)',
        },
        nm: {
          en: 'Daniel Chang',
          ko: '장두현',
        },
      }
    },
    reports: {
      annual: {
        nm: {
          en: 'Annual Report' ,
          ko: '연차보고서' ,
        }
      },
      audit: {
        nm: {
          en: 'Audit Report',
          ko: '감사보고서',
        }
      },
      ir: {
        nm: {
          en: 'IR',
          ko: 'IR',
        }
      }
    },
    space: {
      intro: {
        nm: {
          en: 'Intro',
          ko: 'Intro',
        }
      },
      his: {
        nm: {
          en:'2023 Humans In Space',
          ko:'2023 Humans In Space',
        }
      },
      cis: {
        nm: {
          en:'2022 Care In Space',
          ko:'2022 Care In Space',
        }
      }
    }
  }
}
